
import { defineComponent, onMounted, ref } from 'vue';
import { darkT, themeOverride } from './utils/theme-toggle';
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import { Lightbulb, ChartPie } from '@vicons/fa';
import Alert from './components/Alert.vue';
import Loading from './components/Loading.vue';
import { NThemeEditor } from 'naive-ui';
// import Performance from '@/components/Performance.vue';
import { EthersService as eth } from '@/services';
import BackgroundAnimation from '@/components/shared/BackgroundAnimation.vue'

export default defineComponent({
  components: {
    Header,
    Footer,
    Lightbulb,
    Alert,
    Loading,
    ChartPie,
    NThemeEditor,
    // Performance,
    BackgroundAnimation
  },
  setup () {
    // const showStats = ref(false);

    return {
      darkT,
      themeOverride,
      // showStats,
      ethReactive: eth.reactive.value
    };
  }
});
